import { Bell, CaretRight } from "@phosphor-icons/react";
import { Link, NavLink } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { NavItemType } from "common/types";

import MobileNav from "./MobileNav";

function MobileHeader({ navItems }: { navItems: NavItemType[] }) {
  const {
    id: workspaceId,
    icon_url: workspaceImage,
    rental_account_count: rentalAccountsCount,
    accounts_count: accountsCount,
    name,
  } = useSelectedWorkspaceContext();

  return (
    <div className="sticky top-0 z-nav flex w-full items-center justify-between gap-3 bg-white px-4 h-[68px] shadow-sm">
      <Link
        to="/workspaces"
        className="flex flex-1 items-center gap-x-1.5 rounded-2xl border border-black-200 px-1.5 py-1 transition-colors"
      >
        <WorkspaceImage size="sm" id={workspaceId} imageSrc={workspaceImage} />
        <div className="flex flex-col">
          <span className="line-clamp-1 break-all text-left text-sm-bold">
            {name}
          </span>
          <span className="text-xxs text-black-500">
            {accountsCount
              ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
              : "No accounts"}
            <RenderIf condition={!!rentalAccountsCount}>
              • {rentalAccountsCount} avatar
              {rentalAccountsCount > 1 ? "s" : ""}
            </RenderIf>
          </span>
        </div>
        <CaretRight className="ml-auto size-4 text-black-500" />
      </Link>

      <Button intent="iconOnly" variant="ghost-black" size="lg" asChild>
        <NavLink to="notifications">
          <Bell weight="fill" />
        </NavLink>
      </Button>
      <MobileNav navItems={navItems} />
    </div>
  );
}

export default MobileHeader;
